import React from "react";
import { Main } from "./views/common/layout/Main";

const App = () => <Main />;

export default React.memo(App);
